module.exports = __webpack_public_path__ + "static/media/face4.57604a35.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Components/FeedbackForm/images/face4.svg
// module id = 1224
// module chunks = 2